import socket from "./socket";
import { useUserContext } from "./UserContext";

export default (props: { project: { id: number; name: string } }) => {
  const [userStore, setUserStore, userActions] = useUserContext();

  return (
    <div class="card-panel">
      <div class="mb-4 pb-2 border-bottom">
        <h3 class="h4 fw-bold text-dark mb-1">Paramètres du projet</h3>
        <p class="text-muted small mb-0">Configurez les options d'affichage et gérez le cycle de vie de votre projet.</p>
      </div>

      <div class="row g-4">
        {/* Advanced actions toggle */}
        <div class="col-12">
          <div class="p-3 bg-light rounded-3 border d-flex justify-content-between align-items-center">
            <div>
              <div class="fw-semibold text-dark">Mode avancé & Édition de structure</div>
              <div class="small text-muted">
                Active les fonctionnalités d'ajout, de renommage et de suppression d'étudiants, ainsi que l'édition du modèle d'évaluation.
              </div>
            </div>
            <button
              type="button"
              class={`btn ${userStore.showAdvancedActions ? 'btn-primary' : 'btn-outline-secondary'} d-inline-flex align-items-center gap-2`}
              onClick={() => {
                userActions.toggleShowAdvancedActions();
              }}
            >
              <i class={`bi ${userStore.showAdvancedActions ? 'bi-toggle-on' : 'bi-toggle-off'} fs-5`}></i>
              <span>{userStore.showAdvancedActions ? 'Activé' : 'Désactivé'}</span>
            </button>
          </div>
        </div>

        {/* Danger zone */}
        <div class="col-12">
          <div class="p-4 border border-danger-subtle bg-danger-subtle rounded-3">
            <h5 class="fw-bold text-danger mb-2 d-flex align-items-center gap-2">
              <i class="bi bi-exclamation-triangle-fill"></i>
              Zone de danger
            </h5>
            <p class="small text-danger-emphasis mb-3">
              La suppression d'un projet est définitive. Toutes les notes, appréciations et historiques associés seront définitivement effacés.
            </p>
            <button
              type="button"
              class="btn btn-danger d-inline-flex align-items-center gap-2 shadow-sm"
              onClick={() => {
                if (!confirm(`Confirmez-vous la suppression définitive du projet "${props.project.name}" ?`)) return;
                socket.emit('delete-project', props.project.id);
              }}
            >
              <i class="bi bi-trash3-fill"></i>
              <span>Supprimer définitivement ce projet</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
